// Подключение функций редактора. Каждая функция - папка src/features/<имя>/ с index.ts:
//   export default function setup(r: RegistryApi) { r.commands.add(...); r.ribbonItems.add(...); ... }
// Новая функция подключается ОДНОЙ строкой в список FEATURES (порядок = порядок регистрации).
import type { FeatureSetup } from '../core/registry';
import shell from './shell';
import stoIntel from './sto_intel';
import math from './math';
import tablesFiguresCode from './tables_figures_code';
import pasteImport from './paste_import';
import auth from './auth';
import typing from './typing';
import pages from './pages';

export const FEATURES: FeatureSetup[] = [
  shell,               // оболочка: вкладки ленты, «Главная», «Файл», «Вид», строка состояния
  stoIntel,            // СТО: проверка, титул и метаданные, структура, источники, ссылки, сноски, живые правила
  math,                // формулы: выключные и строчные, редактор, вставка LaTeX/MathML
  tablesFiguresCode,   // рисунки, таблицы, листинги
  pasteImport,         // вставка из буфера и перетаскивание, импорт .docx
  auth,                // учётные записи: вход, меню, профиль, повторный вход; администрирование (features/admin)
  typing,              // клавиатура как в Word, тип строки в строке состояния, «Как писать», выравнивание граф таблиц
  pages,               // «Разметка страницы»: листы A4, построчный перенос, номера страниц, сноски, оглавление, навигатор
];
